import messageResource from '../messageResource'
import CoarseSelection from '../enums/CoarseSelection'
import GroupType from '../enums/GroupType'
import TwoLevelSelection from  '../controls/selectorControls/two_level_selection'
import { Feature, isEnabled } from '../features/index'
import { numberComparator } from '../atUtils'
import { getUserSelectorFeatureStrategy } from '../usersSelector/user_group_selector_util'
import $ from "jquery"
import UserSelectorUtils from '../usersSelector/UserSelectorUtils'

/**
 * Base object representing a single notification rule state.
 *
 *
 */

class RuleState {
    constructor(rule) {
        this.savedState = {};
        this.currentState = null;
        this.rule = rule;
        this.recipientsKey = 'recipients';
        this.cpSelectorKey = 'projects';
        this.cpParamPrefix = 'customers_projects';
        this.ttUsersKey = 'ttUsers';
        this.ttLimitKey = 'ttLimit';
        this.moneyKey = 'money';
    }

    /**
     * Set rule initial state. The method should be called when new rule is created
     */
    setInitialState() {
        this.getCurrentState(true);
        this.savedState = this.currentState;
        this.setStateOfAllUserSelectors();
    }

    update() {
        this.getCurrentState();
        if (this.isValid()) {
            this.savedState = this.currentState;
            return true;
        }
        return false;
    }

    reset() {
        if (this.savedState[this.recipientsKey])
            this.setState();
    }

    isChanged() {
        var currentCpSelectorState;
        var savedCpSelectorState;
        if (this.rule.cpSelector) {
            currentCpSelectorState = this.currentState[this.cpSelectorKey];
            savedCpSelectorState = this.savedState[this.cpSelectorKey];
            if (!this.rule.cpSelector.isAlreadyShown()) {
                delete this.currentState[this.cpSelectorKey];
                delete this.savedState[this.cpSelectorKey];
            }
            else {
                delete this.savedState[this.cpSelectorKey].outputData;
            }
        }
        var result = !equalObjects(this.currentState, this.savedState);
        if (this.rule.cpSelector) {
            this.currentState[this.cpSelectorKey] = currentCpSelectorState;
            this.savedState[this.cpSelectorKey] = savedCpSelectorState;
        }
        return result;
    }

    isValid() {
        return this.checkUsersSelectorParams(this.rule.recipientsSelector, this.recipientsKey);
    }

    focusFirstErroneousInput() {}

    setState() {
        this.rule.disableInputs();
        this.setStateOfAllUserSelectors();
    }

    setStateOfAllUserSelectors() {
        this.setUsersSelectorState(this.rule.recipientsSelector, this.recipientsKey);
    }

    getCurrentState(isInitial) {
        this.currentState = this.getParams(isInitial);
        return this.currentState;
    }

    getParams(isInitial) {
        var params = {};
        params[this.recipientsKey] = {};
        this.fillUsersSelectorParams(params[this.recipientsKey], this.rule.recipientsSelector);
        return params;
    }

    checkRecipients() {
        this.getCurrentState();
        var selector = this.rule.recipientsSelector;
        var selectedUsers = (!selector.selector.isCustomOptionSelected()) ? selector.selector.getLowLevelEntities() :
            // if the selector is shown, a group's children will be selected and returned by getOnlyUsersSelection(),
            // otherwise a initial selection will be used. The initial selection don't have selected group's children for selected groups.
                            (selector.selector.isAlreadyShown() ? selector.selector.getOnlyUsersSelection() : selector.selector.getAllSelectedUsers());
        var hasSuitableUsers = false;

        for (var i = 0; i < selectedUsers.length; i++) {
            if (selectedUsers[i].hasEmail() && selectedUsers[i].isActive() && (!selector.accessRight || selector.accessRight.isGranted(
                    selectedUsers[i].accessRight))) {
                hasSuitableUsers = true;
                break;
            }
        }

        var message = null;
        if (!hasSuitableUsers) {
            message = messageResource.getMessage("mail_notifications.warning.recipients");
            if (selector.accessRight) {
                message += messageResource.getMessage("mail_notifications.warning.recipients.insufficient_rights");
            }
            message += messageResource.getMessage("mail_notifications.warning.recipients.footer");
            return message;
        }

        return message;
    }

    /**
     * Initiates RuleState.
     * NOTE: Inheritors should perform specific initiations first and call parent method after all as it calls setState method.
     * Otherwise it is developer's responsibility to handel any error which may occur.
     * @param params
     */
    initState(params) {
        this.setUsersSelectorParams(params, this.recipientsKey, this.recipientsKey, this.rule.recipientsSelector);
        this.setState();
        this.currentState = this.savedState;
        this.isDaysValid = true;
        this.isTimeValid = true;
    }

    setStateParam(paramName, value) {
        this.savedState[paramName] = value;
    }

    fillUsersSelectorParams(params, selector) {
        params.allUsers = !selector.selector.isCustomOptionSelected();
        var selection = selector.selector.getSelection();
        //sorting of arrays is needed due to check equality of objects in future (Rule state isChanged() method).
        params.selectedGroups = (params.allUsers) ? null : selection.getFirstLevel().sort(numberComparator);
        params.selectedUsers = (params.allUsers) ? null : selection.getSecondLevel().sort(numberComparator);
        params.selectedGroupType = (params.allUsers) ? null : selector.selector.getGroupType();
        params.allUsers = "" + params.allUsers; // a workaround in a purpose of object comparison.
        // Need to have allUsers String, as far as when we get params for saved rules we are received String.
    }

    checkUsersSelectorParams(userSelector, paramName) {
        var selectorParams = this.currentState[paramName];
        if (selectorParams.allUsers == "true" || (selectorParams.selectedUsers.length != 0) || (selectorParams.selectedGroups.length != 0))
            return true;
        userSelector.setDisplayInputError(true, getUserSelectorFeatureStrategy().getEmptySelectionTooltipText());
        return false;
    }

    setUsersSelectorParams(params, prefix, paramName, selector) {
        var featureDependentUserGroups = isEnabled(Feature.UGR) ? this.rule.usersInfo.userGroups : [];
        var featureDependentTZGroups = isEnabled(Feature.TZG) ? this.rule.usersInfo.timeZoneGroups : [];

        var userList = this.rule.usersInfo.users;

        var allUsers = params[String.format('{0}.allUsers', prefix)] || "";
        var selectedUsers = params[String.format('{0}.selectedUsers', prefix)].split(",") || "";
        var selectedGroups = params[String.format('{0}.selectedGroups', prefix)].split(",") || "";
        var selectedGroupType = params[String.format('{0}.selectedGroupType', prefix)] || "";
        var existingUsers = getPropertyValues(selectFromArray(selectedUsers, userList), "id");
        var existingGroups = getPropertyValues(selectFromArray(selectedGroups,
            selectedGroupType == GroupType.TIME_ZONE_GROUP ? featureDependentTZGroups : featureDependentUserGroups), "id");

        var isAllUsers = ( allUsers == "true" );

        var convertedUsers = UserSelectorUtils.convertSelectedGroupsIntoSelectedUsersIfNecessary(userList, selectedGroupType, isAllUsers, false, selectedGroups,
            isEnabled(Feature.UGR), isEnabled(Feature.TZG));

        if (selector.accessRight) {
            convertedUsers = $.grep(convertedUsers, function(user) {
                return selector.accessRight.isGranted(user.accessRight);
            });
        }

        existingUsers = $.merge(existingUsers, getPropertyValues(convertedUsers, "id"));

        this.setStateParam(paramName,
            {
                allUsers: allUsers,
                selectedUsers: isAllUsers ? null : existingUsers,
                selectedGroups: isAllUsers ? null : existingGroups,
                selectedGroupType: isAllUsers ? null : selectedGroupType
            });
        if (!isAllUsers && existingUsers.length == 0 && existingGroups.length == 0)
            this.setParamsError = true;
    }

    setUsersSelectorState(selector, paramName) {
        var users = this.savedState[paramName].selectedUsers;
        var groups = this.savedState[paramName].selectedGroups;
        var groupType = this.savedState[paramName].selectedGroupType;
        var allUsers = this.savedState[paramName].allUsers == "true";
        selector.setInitialSelection(allUsers, new TwoLevelSelection(groups ? groups : [], users ? users : []), groupType);
    }

    fillTTLimitParams(params, ttLimit) {
        params.rangeDays = ttLimit.daysInput.value;
        params.time = ttLimit.timeInput.value;
        params.onlyWorkingDays = ttLimit.dayTypeDropdownBtn.getValue();
    }

    checkTTLimitParams(ttLimit, paramName) {
        this.isDaysValid = this.checkPositiveIntegerInput(ttLimit.daysInput, this.currentState[paramName].rangeDays);
        this.isTimeValid = this.checkTimeInput(ttLimit.timeInput, this.currentState[paramName].time);
        return this.isDaysValid && this.isTimeValid;
    }

    checkPositiveIntegerInput(input, value, message) {
        var errorMessage = null;

        if (!isUnsignedPositiveInteger(value)) {
            if (typeof message === "undefined")
                message = messageResource.getMessage("mail_notifications.form.input.invalid_data.positive_integer");
            errorMessage = message;
        }
        errorMessage = this.checkNotEmpty(value, errorMessage);
        this.displayInputError(input, errorMessage);
        return errorMessage == null;
    }

    checkTimeInput(input, value) {
        return this.checkPositiveIntegerInput(input, value,
            messageResource.getMessage('mail_notifications.form.input.invalid_data.positive_time', [SystemSettings.decimalSeparator]));
    }

    checkNotEmpty(value, message) {
        if (value.length == 0) {
            message = messageResource.getMessage("mail_notifications.form.input.invalid_data.empty");
        }
        return message;
    }

    displayInputError(input, message) {
        if (message)
            input.setDisplayInputError(true, message);
    }

    setTTLimitParams(params, prefix, paramName) {
        this.setStateParam(paramName,
            {
                rangeDays: params[String.format('{0}.rangeDays', prefix)],
                time: params[String.format('{0}.time', prefix)],
                onlyWorkingDays: params[String.format('{0}.onlyWorkingDays', prefix)]
            });
    }

    setTTLimitState(ttLimit, paramName) {
        ttLimit.daysInput.value = this.savedState[paramName].rangeDays;
        ttLimit.timeInput.value = this.savedState[paramName].time;

        var workingDays = this.savedState[paramName].onlyWorkingDays;
        ttLimit.dayTypeDropdownBtn.currentValue = workingDays;
        ttLimit.dayTypeDropdownBtn.setActiveItemByValue(workingDays);
        ttLimit.dayTypeSelect.updateData(ttLimit.dayTypeDropdownBtn.getText());
    }

    initTTLimitState(ttLimit, paramName) {
        ttLimit.daysInput.init(this.savedState[paramName].rangeDays);
        ttLimit.timeInput.init(this.savedState[paramName].time);
        //ttLimit.dayTypeSelect.init ( this.savedState[paramName].onlyWorkingDays );
    }

    fillCPSelectorParams(params, cpSelector, isInitial) {
        if (isInitial) {
            params.coarseSelection = CoarseSelection.ALL;
            params.showArchived = false;
            params.customerList = "";
            params.projectList = "";
        }
        else if (cpSelector.isAlreadyShown()) {
            var state = cpSelector.getState();
            params.coarseSelection = state.optionValue;
            params.showArchived = state.showInactive;
            var customersCSV = "";
            var projectsCSV = "";
            if (cpSelector.isCustomOptionSelected()) {
                //sorting of arrays is needed due to check equality of objects in future (Rule state isChanged() method).
                customersCSV = state.selection.getFirstLevel().sort(numberComparator).join();
                projectsCSV = state.selection.getSecondLevel().sort(numberComparator).join();
            }
            params.customerList = customersCSV;
            params.projectList = projectsCSV;
        }
        else {
            var savedState = this.savedState[this.cpSelectorKey];
            params.coarseSelection = savedState.coarseSelection;
            params.showArchived = savedState.showArchived;
            params.customerList = savedState.customerList;
            params.projectList = savedState.projectList;
            params.outputData = savedState.outputData;
        }
    }

    checkCPSelectorParams(cpSelectorButton, paramName) {
        var cpSelectorParams = this.currentState[paramName];
        if (cpSelectorParams.coarseSelection != CoarseSelection.SPECIFIC ||
            cpSelectorParams.projectList.length != 0 ||
            cpSelectorParams.customerList.length != 0)
            return true;
        cpSelectorButton.setDisplayInputError(true,
            messageResource.getEscapedMessage("mail_notifications.projects_customers_selector.error.no_projects_customers_selected"));
        return false;
    }

    setCPSelectorParams(params, prefix, paramName) {
        var coarseSelection = params[String.format('{0}.coarseSelection', prefix)];
        var projectList = params[String.format('{0}.projectList', prefix)] || "";
        var customerList = params[String.format('{0}.customerList', prefix)] || "";
        var outputData = params.customerProjectOutputData;
        var existingProjects = projectList.split(',');
        var existingCustomers = customerList.split(',');
        this.setStateParam(paramName,
            {
                coarseSelection: coarseSelection,
                showArchived: params[String.format('{0}.showArchived', prefix)] == 'true',
                projectList: existingProjects.toString(),
                customerList: existingCustomers.toString(),
                outputData: outputData
            }
        );

        //to pause the Rule
        if (coarseSelection == CoarseSelection.SPECIFIC && existingProjects.length == 0 && existingCustomers.length == 0)
            this.setParamsError = true;
    }

    setCPSelectorState(cpSelector, paramName) {
        var state = {};

        state.optionValue = this.savedState[paramName].coarseSelection;
        state.showInactive = this.savedState[paramName].showArchived;
        state.selection = (state.optionValue == CoarseSelection.SPECIFIC) ?
                          new TwoLevelSelection(safeSplit(this.savedState[paramName].customerList, ','),
                              safeSplit(this.savedState[paramName].projectList, ',')) :
                          TwoLevelSelection.emptySelection();
        if (cpSelector.isAlreadyShown()) {
            cpSelector.setPredefinedParameters(state);
            cpSelector.loadState(state);
        }
        else {
            this.rule.cpSelectorButton.setText(CPSelectorClientUtil.makePredefinedSelection(cpSelector, state, this.savedState[paramName].outputData));
            this.rule.cpSelector.setGetPredefinedSelectionCallback(function() {return state});
        }
    }

    checkMoneyConditionParams(moneyCondition, paramName) {
        return this.checkPositiveIntegerInput(moneyCondition.amountInput, this.currentState[paramName].amount);
    }

    fillMoneyConditionParams(params, moneyCondition) {
        params.rangeName = moneyCondition.timeRangeDropdownBtn.getValue();
        params.amount = moneyCondition.amountInput.value;
    }

    setMoneyConditionParams(params, prefix, paramName) {
        this.setStateParam(paramName,
            {
                rangeName: params[String.format('{0}.range', prefix)],
                amount: new Number(params[String.format('{0}.amount', prefix)])
            }
        );
    }

    setMoneyConditionState(moneyCondition, paramName) {
        var amount = this.savedState[paramName].amount;
        var rangeName = this.savedState[paramName].rangeName;
        if (amount && !isNaN(amount))
            moneyCondition.amountInput.value = amount;

        if (rangeName) {
            moneyCondition.timeRangeDropdownBtn.currentValue = rangeName;
            moneyCondition.timeRangeDropdownBtn.setActiveItemByValue(rangeName);
            moneyCondition.timeRangeSelect.updateData(moneyCondition.timeRangeDropdownBtn.getText());
        }
    }
}


/**
 * PersonalTTRuleState
 */


export class PersonalTTRuleState extends RuleState {
    constructor(rule) {
        super(rule);
    }

    isValid() {
        var checkDefault = RuleState.prototype.isValid.call(this);
        var checkTTLimit = this.checkTTLimitParams(this.rule.ttLimit, this.ttLimitKey);
        return checkDefault && checkTTLimit;
    }

    focusFirstErroneousInput() {
        if (!this.isTimeValid)
            this.rule.ttLimit.timeInput.focus();
        else if (!this.isDaysValid)
            this.rule.ttLimit.daysInput.focus();
    }

    setState() {
        super.setState();
        this.setTTLimitState(this.rule.ttLimit, this.ttLimitKey);
    }

    getParams(isInitial) {
        var params = super.getParams(isInitial);
        params[this.ttLimitKey] = {};
        this.fillTTLimitParams(params[this.ttLimitKey], this.rule.ttLimit);
        return params;
    }

    initState(params) {
        this.setTTLimitParams(params, 'tt_limit', this.ttLimitKey);
        this.initTTLimitState(this.rule.ttLimit, this.ttLimitKey);
        RuleState.prototype.initState.call(this, params);
    }
}


/**
 * UnsubmittedTTRuleState
 */


export class UnsubmittedTTRuleState extends RuleState {
    constructor(rule) {
        super(rule);
    }

    isValid() {
        var checkDefault = RuleState.prototype.isValid.call(this);
        var checkUsers = this.checkUsersSelectorParams(this.rule.ttUsersSelector, this.ttUsersKey);
        var checkTTLimit = this.checkTTLimitParams(this.rule.ttLimit, this.ttLimitKey);
        return checkDefault && checkUsers && checkTTLimit;
    }

    focusFirstErroneousInput() {
        if (!this.isTimeValid)
            this.rule.ttLimit.timeInput.focus();
        else if (!this.isDaysValid)
            this.rule.ttLimit.daysInput.focus();
    }

    setState() {
        super.setState();
        this.setTTLimitState(this.rule.ttLimit, this.ttLimitKey);
    }

    setStateOfAllUserSelectors() {
        super.setStateOfAllUserSelectors();
        this.setUsersSelectorState(this.rule.ttUsersSelector, this.ttUsersKey);
    }

    getParams(isInitial) {
        var params = super.getParams(isInitial);
        params[this.ttLimitKey] = {};
        this.fillTTLimitParams(params[this.ttLimitKey], this.rule.ttLimit);
        params[this.ttUsersKey] = {};
        this.fillUsersSelectorParams(params[this.ttUsersKey], this.rule.ttUsersSelector);
        return params;
    }

    initState(params) {
        this.setTTLimitParams(params, 'tt_limit', this.ttLimitKey);
        this.setUsersSelectorParams(params, 'tt_users', this.ttUsersKey, this.rule.ttUsersSelector);
        this.initTTLimitState(this.rule.ttLimit, this.ttLimitKey);

        RuleState.prototype.initState.call(this, params);
    }
}


/**
 * DeadlineRuleState
 */


export class DeadlineRuleState extends RuleState {
    constructor(rule) {
        super(rule);
        this.deadlineKey = 'deadline';
        this.stateButtonKey = 'stateButtonValue';
        this.isDeadlineValid = true;
    }

    isValid() {
        var checkDefault = RuleState.prototype.isValid.call(this);
        var checkCP = this.checkCPSelectorParams(this.rule.cpSelectorButton, this.cpSelectorKey);
        this.isDeadlineValid = this.checkDeadlineConditionParams(this.rule.deadlineCondition);
        return checkDefault && checkCP && this.isDeadlineValid;
    }

    focusFirstErroneousInput() {
        if (!this.isDeadlineValid)
            this.rule.deadlineCondition.focus();
    }

    setState() {
        super.setState();
        this.setCPSelectorState(this.rule.cpSelector, this.cpSelectorKey);
        this.setDeadlineConditionState(this.rule.deadlineCondition);
    }

    getParams(isInitial) {
        var params = super.getParams(isInitial);
        params[this.cpSelectorKey] = {};
        this.fillCPSelectorParams(params[this.cpSelectorKey], this.rule.cpSelector, isInitial);
        this.fillDeadlineConditionParams(params, this.rule.deadlineCondition);
        return params;
    }

    initState(params) {
        this.setCPSelectorParams(params, this.cpParamPrefix, this.cpSelectorKey);
        this.setDeadlineConditionParams(params);
        this.rule.deadlineCondition.daysInput.init(Math.abs(this.savedState[this.deadlineKey]));
        this.rule.deadlineCondition.stateSelect.init(this.rule.deadlineCondition.stateBtn.getText());

        RuleState.prototype.initState.call(this, params);
        this.rule.deadlineCondition.daysInput.disableInput();
    }

    checkDeadlineConditionParams(deadlineCondition) {
        if (this.currentState[this.stateButtonKey] == DeadlineCondition.TODAY)
            return true;

        return this.checkPositiveIntegerInput(deadlineCondition.daysInput,
            deadlineCondition.daysInput.value);
    }

    fillDeadlineConditionParams(params, deadlineCondition) {
        var stateValue = deadlineCondition.stateBtn.getValue();
        if (stateValue == DeadlineCondition.TODAY) {
            params[this.deadlineKey] = 0;
        }
        else if (stateValue == DeadlineCondition.MISSED) {
            params[this.deadlineKey] = (-1 * deadlineCondition.daysInput.value).toString();
        }
        else {
            params[this.deadlineKey] = deadlineCondition.daysInput.value;
        }
        params[this.stateButtonKey] = stateValue;
    }

    setDeadlineConditionParams(params) {
        var deadline = new Number(params[this.deadlineKey]);
        var stateButtonValue;

        if (!deadline || isNaN(deadline)) return;
        stateButtonValue = this.getDeadlineConditionStateButtonValue(deadline);
        this.savedState[this.stateButtonKey] = stateButtonValue;
        this.savedState[this.deadlineKey] = deadline;
    }

    getDeadlineConditionStateButtonValue(deadlineValue) {
        var deadline = parseFloat(deadlineValue);
        if (isNaN(deadline))
            return -1;
        if (deadline > 0)
            return DeadlineCondition.COMING_UP;
        else if (deadline < 0)
            return DeadlineCondition.MISSED;
        else
            return DeadlineCondition.TODAY;
    }

    setDeadlineConditionState(deadlineCondition) {
        deadlineCondition.stateBtn.currentValue = this.savedState[this.stateButtonKey];
        deadlineCondition.stateBtn.setActiveItemByPosition(this.savedState[this.stateButtonKey] - 1);

        deadlineCondition.stateBtn.fireEvent('change', deadlineCondition.stateBtn);

        var inputValue = this.savedState[this.deadlineKey] == "" ? "" : Math.abs(this.savedState[this.deadlineKey]);
        deadlineCondition.daysInput.value = inputValue;
        deadlineCondition.stateSelect.updateData(deadlineCondition.stateBtn.getText());
    }
}


/**
 * EstimateRuleState
 */


export class EstimateRuleState extends RuleState {
    constructor(rule) {
        super(rule);
        this.percentsKey = 'estimatePercents';
        this.isPercentsValid = true;
    }

    isValid() {
        var checkDefault = RuleState.prototype.isValid.call(this);
        var checkCP = this.checkCPSelectorParams(this.rule.cpSelectorButton, this.cpSelectorKey);
        this.isPercentsValid = this.checkPositiveIntegerInput(this.rule.estimateInput, this.currentState[this.percentsKey]);
        return checkDefault && checkCP && this.isPercentsValid;
    }

    focusFirstErroneousInput() {
        if (!this.isPercentsValid)
            this.rule.estimateInput.focus();
    }

    setState() {
        super.setState();
        this.setCPSelectorState(this.rule.cpSelector, this.cpSelectorKey);
        this.rule.estimateInput.value = this.savedState[this.percentsKey];
    }

    getParams(isInitial) {
        var params = super.getParams(isInitial);
        params[this.cpSelectorKey] = {};
        this.fillCPSelectorParams(params[this.cpSelectorKey], this.rule.cpSelector, isInitial);
        params[this.percentsKey] = this.rule.estimateInput.value;
        return params;
    }

    initState(params) {
        this.setCPSelectorParams(params, this.cpParamPrefix, this.cpSelectorKey);
        this.savedState[this.percentsKey] = params[this.percentsKey];
        if (!isNaN(this.savedState[this.percentsKey]))
            this.rule.estimateInput.init(this.savedState[this.percentsKey]);
        this.rule.estimateInput.setValidator(new IntegerInputControlValidator(1));
        RuleState.prototype.initState.call(this, params);
    }
}


/**
 * ProjectBudgetRuleState
 */


export class ProjectBudgetRuleState extends RuleState {
    constructor(rule) {
        super(rule);
        this.isMoneyValid = true;
    }

    isValid() {
        var checkDefault = RuleState.prototype.isValid.call(this);
        var checkCP = this.checkCPSelectorParams(this.rule.cpSelectorButton, this.cpSelectorKey);
        this.isMoneyValid = this.checkMoneyConditionParams(this.rule.moneyCondition, this.moneyKey);
        return checkDefault && checkCP && this.isMoneyValid;
    }

    focusFirstErroneousInput() {
        if (!this.isMoneyValid)
            this.rule.moneyCondition.focus();
    }

    setState() {
        super.setState();
        this.setCPSelectorState(this.rule.cpSelector, this.cpSelectorKey);
        this.setMoneyConditionState(this.rule.moneyCondition, this.moneyKey);
    }

    getParams(isInitial) {
        var params = super.getParams(isInitial);
        params[this.cpSelectorKey] = {};
        this.fillCPSelectorParams(params[this.cpSelectorKey], this.rule.cpSelector, isInitial);
        params[this.moneyKey] = {};
        this.fillMoneyConditionParams(params[this.moneyKey], this.rule.moneyCondition);
        return params;
    }

    initState(params) {
        this.setCPSelectorParams(params, this.cpParamPrefix, this.cpSelectorKey);
        this.setMoneyConditionParams(params, this.moneyKey, this.moneyKey);
        var amount = this.savedState[this.moneyKey].amount;
        if (amount && !isNaN(amount))
            this.rule.moneyCondition.amountInput.init(amount);

        RuleState.prototype.initState.call(this, params);

    }
}


/**
 * PersonalEarningsRuleState
 */


export class PersonalEarningsRuleState extends RuleState {
    constructor(rule) {
        super(rule);
        this.ttUsersKey = 'ttUsers';
        this.moneyKey = 'money';
        this.isMoneyValid = true;
    }

    isValid() {
        var checkDefault = RuleState.prototype.isValid.call(this);
        var checkUsers = this.checkUsersSelectorParams(this.rule.ttUsersSelector, this.ttUsersKey);
        this.isMoneyValid = this.checkMoneyConditionParams(this.rule.moneyCondition, this.moneyKey);
        return checkDefault && checkUsers && this.isMoneyValid;
    }

    focusFirstErroneousInput() {
        if (!this.isMoneyValid)
            this.rule.moneyCondition.focus();
    }

    setState() {
        super.setState();
        this.setMoneyConditionState(this.rule.moneyCondition, this.moneyKey);
    }

    setStateOfAllUserSelectors() {
        super.setStateOfAllUserSelectors();
        this.setUsersSelectorState(this.rule.ttUsersSelector, this.ttUsersKey);
    }

    getParams(isInitial) {
        var params = super.getParams(isInitial);
        params[this.ttUsersKey] = {};
        this.fillUsersSelectorParams(params[this.ttUsersKey], this.rule.ttUsersSelector);
        params[this.moneyKey] = {};
        this.fillMoneyConditionParams(params[this.moneyKey], this.rule.moneyCondition);
        return params;
    }

    initState(params) {
        this.setUsersSelectorParams(params, 'tt_users', this.ttUsersKey, this.rule.ttUsersSelector);
        this.setMoneyConditionParams(params, this.moneyKey, this.moneyKey);
        var amount = this.savedState[this.moneyKey].amount;
        if (amount && !isNaN(amount))
            this.rule.moneyCondition.amountInput.init(amount);

        RuleState.prototype.initState.call(this, params);
    }
}


















// WEBPACK FOOTER //
// ./web/js/notifications/RuleState.js